import React from "react";

function TermsAndConditions() {
	return <h2>Terms And Conditions</h2>;
}

export default TermsAndConditions;
